import type Trail from '@alltrails/types/Trail';
import type { ShareObject } from '@alltrails/sharing/types/ShareObject';

const getTrailShareObject = ({ id, slug, name }: Trail): ShareObject => ({
  type: 'trail',
  id,
  slug: `trail/${slug}`,
  name,
  primaryKey: 'trail_id'
});

export default getTrailShareObject;
